export default __webpack_public_path__ + "static/media/result_cardiac_good.eaeb923d.jpg";